"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.StyledTableRow=exports.StyledTableInner=exports.StyledTableCellInner=exports.StyledTableCell=exports.StyledTableBody=exports.StyledTable=void 0;var _styledComponents=_interopRequireDefault(require("styled-components"));var _constants=require("../../_constants");var _utils=require("../_utils");var _utils2=require("./_utils");function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e};}const StyledTableCell=exports.StyledTableCell=_styledComponents.default.td`
  padding: 0;
  vertical-align: ${props=>props.sVAlign};
  border-bottom: ${props=>(0,_utils2.getTableCellBorder)('horizontal',props.sBorder)};
  border-right: ${props=>(0,_utils2.getTableCellBorder)('vertical',props.sBorder)};
`;const StyledTableCellInner=exports.StyledTableCellInner=_styledComponents.default.div`
  position: relative;
  box-sizing: border-box;
  text-align: ${props=>(0,_utils.getTextAlign)(props.sTextAlign)};
`;const StyledTableRow=exports.StyledTableRow=_styledComponents.default.tr`
  ${StyledTableCell} {
    vertical-align: ${props=>(0,_utils.getVerticalAlign)(props.sVerticalAlign)};
  }
`;const StyledTable=exports.StyledTable=_styledComponents.default.div`
  position: relative;
  box-sizing: border-box;
  margin: ${props=>(0,_utils2.getTableSpacing)(props.sSpacing,props.isRemoveSideSpacing,_constants.MEDIA_SIZES.S)};
  font-size: ${_ref=>{let{theme,sSize}=_ref;return(0,_utils.getFontSize)({theme,size:sSize,mediaSize:_constants.MEDIA_SIZES.S});}};

  ${StyledTableCellInner} {
    padding: ${props=>(0,_utils.getSpacing)(props.sSpacing,_constants.MEDIA_SIZES.S)};

    :first-child {
      padding-left: ${props=>props.isRemoveSideSpacing?0:(0,_utils.getSpacing)(props.sSpacing,_constants.MEDIA_SIZES.S)};
    }

    :last-child {
      padding-right: ${props=>props.isRemoveSideSpacing?0:(0,_utils.getSpacing)(props.sSpacing,_constants.MEDIA_SIZES.S)};
    }
  }

  @media (${_constants.MEDIA.TABLET}) {
    margin: -${props=>(0,_utils2.getTableSpacing)(props.sSpacing,props.isRemoveSideSpacing,_constants.MEDIA_SIZES.M)};
    font-size: ${_ref2=>{let{theme,sSize}=_ref2;return(0,_utils.getFontSize)({theme,size:sSize,mediaSize:_constants.MEDIA_SIZES.M});}};

    ${StyledTableCellInner} {
      padding: ${props=>(0,_utils.getSpacing)(props.sSpacing,_constants.MEDIA_SIZES.M)};
    }
  }

  @media (${_constants.MEDIA.DESKTOP}) {
    margin: -${props=>(0,_utils2.getTableSpacing)(props.sSpacing,props.isRemoveSideSpacing,_constants.MEDIA_SIZES.L)};
    font-size: ${_ref3=>{let{theme,sSize}=_ref3;return(0,_utils.getFontSize)({theme,size:sSize,mediaSize:_constants.MEDIA_SIZES.L});}};

    ${StyledTableCellInner} {
      padding: ${props=>(0,_utils.getSpacing)(props.sSpacing,_constants.MEDIA_SIZES.L)};
    }
  }
`;const StyledTableInner=exports.StyledTableInner=_styledComponents.default.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  border-top: ${props=>(0,_utils2.getTableCellBorder)('horizontal',props.sBorder)};
  border-left: ${props=>(0,_utils2.getTableCellBorder)('vertical',props.sBorder)};
`;const StyledTableBody=exports.StyledTableBody=_styledComponents.default.tbody``;